import * as React from 'react';
import { SVGProps } from 'react';
const LinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={11}
    fill="none"
    viewBox="0 0 13 11"
    {...props}
  >
    <path
      fill="#fff"
      d="M5.754 8.79a.656.656 0 0 1 0 .93l-.28.28a3.185 3.185 0 0 1-2.267.938A3.205 3.205 0 0 1 .939 5.464l1.9-1.9a3.207 3.207 0 0 1 5.39 1.537.656.656 0 1 1-1.277.298 1.895 1.895 0 0 0-3.184-.907l-1.9 1.9a1.893 1.893 0 1 0 2.676 2.679l.28-.28a.656.656 0 0 1 .93 0ZM11.751.94a3.207 3.207 0 0 0-4.536 0l-.279.279a.657.657 0 0 0 .93.93l.28-.28a1.895 1.895 0 1 1 2.68 2.679L8.921 6.446A1.88 1.88 0 0 1 7.582 7 1.894 1.894 0 0 1 5.74 5.54a.656.656 0 0 0-1.279.297A3.207 3.207 0 0 0 7.58 8.313h.002a3.187 3.187 0 0 0 2.268-.94l1.9-1.9a3.204 3.204 0 0 0 0-4.534Z"
    />
  </svg>
);
export default LinkIcon;
